

export const videosData = [
  {
    id: "1",
    title: "Introduction au projet FORESTT-HUB",
    description: "Présentation générale du projet-ciblé FORESTT-HUB et de ses objectifs principaux.",
    date: "2024-01-15",
    youtubeId: "dQw4w9WgXcQ",
    duration: "5:30",
    tags: ["Formation", "Innovation", "Présentation", "Recherche", "Webinaire"]
  },
  {
    id: "2",
    title: "Gestion durable des forêts",
    description: "Webinaire sur les pratiques de gestion durable des écosystèmes forestiers.",
    date: "2023-12-10",
    youtubeId: "dQw4w9WgXcQ",
    duration: "12:45",
    tags: ["Formation", "Recherche", "Webinaire"]
  },
  {
    id: "3",
    title: "Changements climatiques et forêts",
    description: "Conférence sur l'impact du changement climatique sur les écosystèmes forestiers.",
    date: "2023-11-22",
    youtubeId: "dQw4w9WgXcQ",
    duration: "18:20",
    tags: ["Innovation", "Présentation", "Recherche"]
  },
  {
    id: "4",
    title: "Biodiversité forestière",
    description: "Tutoriel sur la conservation de la biodiversité dans les milieux forestiers.",
    date: "2023-10-05",
    youtubeId: "dQw4w9WgXcQ",
    duration: "8:15",
    tags: ["Formation", "Innovation", "Recherche"]
  }
];

